<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        <i class="mdi mdi-car"></i>
        지오펜스출입이력위치
    </h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col">
            <div id="map-container-01" class="overflow-hidden position-relative" style="width: 100%;height: 70vh;"></div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        취소
    </button>
</div>